import ChannelCommunication from './ChannelCommunication';
import ChannelName from './ChannelName';
import ChannelItems from './ChannelItems';
import ChannelFaqs from './ChannelFaqs';
import ChannelMessageLists from './ChannelMessageLists';
import ChannelEmbedded from './ChannelEmbedded';
import ChannelSettings from './ChannelSettings';
import ListChannels from './ListChannels';
import SortableMultipleSelect from "./SortableMultipleSelect";

window.Vue.component('PartnerChannelCommunication', ChannelCommunication);
window.Vue.component('PartnerChannelName', ChannelName);
window.Vue.component('PartnerChannelItems', ChannelItems);
window.Vue.component('PartnerChannelFaqs', ChannelFaqs);
window.Vue.component('PartnerChannelMessageLists', ChannelMessageLists);
window.Vue.component('PartnerChannelEmbedded', ChannelEmbedded);
window.Vue.component('PartnerChannelSettings', ChannelSettings);
window.Vue.component('PartnerListChannels', ListChannels);
window.Vue.component('SortableMultipleSelect', SortableMultipleSelect);
